import React from "react";

const DwellMarketText = () => {
  return (
    <h5 className="m-0">Dwellworks Living Market Rates</h5>
  );
};

export default DwellMarketText;
